import React from 'react';
import PropTypes from 'prop-types';
import Post from './Post';
import StudentPost from './StudentPost';

export default class PostsList extends React.Component {
  static propTypes = {
    posts: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
    onDestroyPost: PropTypes.func,
    onUntagPost: PropTypes.func,
    updatePosts: PropTypes.func,
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      posts: props.posts,
      type: props.type,        // "albumPost" or "studentPost"
      userRoleInfo: props.userRoleInfo
    };

    // bind this

  }



  componentWillReceiveProps(newProps) {
    this.setState({
      posts: newProps.posts,
      userRoleInfo: newProps.userRoleInfo
    });
  }

  render() {
    return (
      <div className="posts-list-container">
        {this.state.posts && this.state.posts.map(post =>
          this.state.type === "albumPost" ? (<Post post={post} key={post.id} userRoleInfo={this.state.userRoleInfo} onDestroyPost={this.props.onDestroyPost} updatePosts={this.props.updatePosts} />) : (<StudentPost post={post} key={post.id} userRoleInfo={this.state.userRoleInfo} onDestroyPost={this.props.onDestroyPost} onUntagPost={this.props.onUntagPost} />)
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/album/PostsList.jsx